import styled, { css } from 'styled-components';

export const Root = styled.div`
  flex-shrink: 0;
  border-radius: 4px;
  overflow: hidden;
`;

export const Mock = styled.div<{ $size: number }>`
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(90deg, #7ba0ff 0%, #6066f3 100%);
  color: white;
  line-height: 1;

  ${({ $size }) => css`
    width: ${$size}px;
    height: ${$size}px;
    border-radius: ${$size}px;
    padding-top: ${Math.ceil($size / 16)}px;
    font-size: ${Math.ceil($size / 1.8)}px;
  `}
`;
